module.exports = __webpack_public_path__ + "static/img/DSC_2692.7c79cee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_2692.jpg
// module id = 276
// module chunks = 0